module.exports = __webpack_public_path__ + "media/images/icons/flag-pl-ae1299007e2e73e68344db57b7be3069.svg";